import { all, takeLatest, call, put } from 'redux-saga/effects';
import {
  updateProfileAction
} from './Profile.actions';
import { Action } from '@reduxjs/toolkit';
import PersonService from "../../service/Persons.service";
import {User} from "../../domains/app";
import {setUser} from '../App/App.slice';


function* updateProfileSaga(action: Action){
  try{
    if(updateProfileAction.match(action)){
      const res: User = yield call(PersonService.updateProfile, action.payload);
      yield put(setUser(res));
    }
  } catch (e) {
    console.error('profile err', e)
  }
}

// eslint-disable-next-line
export default function* () {
  yield all([
    takeLatest(updateProfileAction.toString(), updateProfileSaga),
  ]);
}
